import { FuelButton } from '@frete.com/fuel-react';
import React from 'react';
import useFeaturesAllowed from '@hooks/useFeaturesAllowed';
import { useNavigate } from 'react-router-dom';
import useAmplitude from '@hooks/useAmplitude';
import { ButtonCreateJourneyPropsInterface } from './ButtonCreateJourneyTypes';

function ButtonCreateJourney({ fullWidth }: ButtonCreateJourneyPropsInterface) {
  const { requestUpdateFeaturesAllowed, isloadingFeatureAllowed } =
    useFeaturesAllowed();
  const navigate = useNavigate();
  const { amplitudeEvent } = useAmplitude();
  const featureCreateProposalName = 'create-proposal';
  const route = 'cadastrar';

  return (
    <FuelButton
      size="large"
      trailingIcon="plus-rounded"
      onClick={() => {
        amplitudeEvent('journey_create_proposal_clicked', {
          source: 'button-criar-viagem',
        });
        requestUpdateFeaturesAllowed(featureCreateProposalName).finally(() => {
          navigate(route);
        });
      }}
      isLoading={isloadingFeatureAllowed(featureCreateProposalName)}
      fullWidth={fullWidth}
    >
      Monitorar
    </FuelButton>
  );
}

export default ButtonCreateJourney;
